// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"modals_tableWrapper__3nGO8"};